import { SVGProps } from 'react';

const ArrowDownWideNarrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11 16-4 4-4-4m4 4V4m4 0h10M11 8h7m-7 4h4"
    />
  </svg>
);
export default ArrowDownWideNarrow;
